import React, { useState } from 'react';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';
import { IconClose } from '@consta/uikit/IconClose';
import { RadioGroup } from '@consta/uikit/RadioGroup';

const cx = cn.bind(styles);

export interface ItemRadio {
  name: string;
  id: string;
}

export interface CloseModalProps {
  setModalOpenBlocking: (item: boolean) => void;
  handleClick: () => void;
  handleChangeRadio?: (value: ItemRadio) => void;
  title: string;
  text: string;
  textButton: string;
  iconClose?: any;
  itemsRadio?: ItemRadio[];
  loading?: boolean;
}

export const CloseModal: React.FC<CloseModalProps> = ({
  setModalOpenBlocking,
  handleClick = () => {},
  handleChangeRadio = () => {},
  title,
  text,
  textButton,
  iconClose = IconClose,
  itemsRadio,
  loading,
}) => {
  const [radioItem, setRadionItem] = useState(
    itemsRadio ? itemsRadio[0] : null,
  );
  return (
    <div className={cx('CloseModal')}>
      <div className={cx('CloseModal__row')}>
        <Text weight="semibold" size="l">
          {title}
        </Text>
        <Button
          onClick={() => {
            setModalOpenBlocking(false);
          }}
          className={cx('CloseModal__button')}
          size="s"
          view="clear"
          iconRight={iconClose}
          onlyIcon
        />
      </div>
      <Text className={cx('CloseModal__text')} size="l">
        {text}
      </Text>
      {itemsRadio && (
        <RadioGroup
          value={radioItem}
          items={itemsRadio}
          getLabel={(item) => item.name}
          onChange={({ value }) => {
            setRadionItem(value);
            handleChangeRadio(value);
          }}
        />
      )}
      <div className={cx('CloseModal__save')}>
        <Button
          onClick={() => {
            setModalOpenBlocking(false);
          }}
          label="Отмена"
          size="m"
          view="ghost"
          className={cx('CloseModal__buttonSave')}
        />
        <Button
          onClick={handleClick}
          size="m"
          label={textButton}
          loading={loading}
        />
      </div>
    </div>
  );
};
